import * as React from "react";
const SvgFiRrMushroom = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-mushroom_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.083 0 11.33c.034 4.28 4.67 4.22 7.728 2.6A30.5 30.5 0 0 0 7 19a5 5 0 1 0 10 0 30.5 30.5 0 0 0-.728-5.071c3.7 1.888 7.786 1.294 7.728-2.6C24 5.083 18.617 0 12 0m3 19a3 3 0 0 1-6 0c.139-1.948.452-3.879.936-5.77a9.55 9.55 0 0 1 4.128 0c.484 1.891.797 3.822.936 5.77m5-6c-2.62-.38-4.632-2.09-8-2-3.366-.091-5.383 1.621-8 2-1.758 0-2-.8-2-1.67C2 6.186 6.486 2 12 2s10 4.186 10 9.33c0 1.083-.319 1.67-2 1.67"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-mushroom_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMushroom;
